import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Number } from 'synapse-ui';

const NumberQuestion = ({ isDisabled, onChange, question }) =>
  <Number
    inputProps={{'data-testid': 'flexible-card__number'}}
    defaultValue={get(question, 'data.value', '')}
    isDisabled={isDisabled}
    onChange={(newValue) => onChange(newValue, 'data.value')}
  />;

NumberQuestion.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  question: PropTypes.shape({
    data: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
    }).isRequired,
  }).isRequired,
};

export default NumberQuestion;
